import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ClientItemId } from 'owa-client-ids';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint } from 'owa-mail-reading-pane-store';
import { ActionSource } from 'owa-analytics-actions';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';

export default action('printItem')(async function printItem(
    itemId: ClientItemId,
    actionSource: ActionSource
) {
    const restrictionToConfirm = <IRMRestrictions>{ PrintAllowed: true };
    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(strings.irm_actionNotAllowedOnThisItem, strings.itemHeaderPrint)
        )
    ) {
        lazyPrint.importAndExecute(itemId, actionSource);
        onPrintRow();
    }
});
